var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104.9 104.9",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-marker"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.7,30c-1.3-2-2.8-3.8-4.6-5.4c-3.4-3-7.3-4.9-11.7-6c-4.7-1.1-9.3-0.9-13.9,0.5c-3.7,1.1-7.1,3-9.9,5.6 c-2,1.8-3.7,3.9-5,6.1c-1.5,2.5-2.4,5.3-3,8.4c-0.7,4.1-0.4,8.1,0.6,12.1c1.6,6.6,4.8,12.6,8.3,18.3c2.6,4.3,5.5,8.4,8.6,12.3 c2.7,3.4,5.4,6.7,8.2,10.1c0.2-0.2,8.1-9.4,11.6-14.2c3.6-4.9,6.9-10,9.6-15.5c2.1-4.3,3.9-8.7,4.7-13.5c0.7-4.4,0.6-8.7-0.8-13 C76.7,33.8,75.9,31.9,74.7,30L74.7,30z M52.4,56.4c-6.5,0-11.7-5.2-11.7-11.7c0-6.5,5.2-11.7,11.7-11.7s11.7,5.2,11.7,11.7 C64.2,51.1,58.9,56.4,52.4,56.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.3ee8742286413d8718f536f39fa3f573.svg";
export { ForwardRef as ReactComponent };